module.exports = __webpack_public_path__ + "static/media/NFSB10.7fd1ea72.jpg";